var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlantSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.75C16.2937 3.75 20.67 6.59438 22.8694 10.7644C25.0763 7.65563 28.7062 5.625 32.8125 5.625H39.375V10.3125C39.375 17.0437 33.9188 22.5 27.1875 22.5H24.375V24.375H33.75V37.5C33.75 39.5719 32.0719 41.25 30 41.25H15C12.9281 41.25 11.25 39.5719 11.25 37.5V24.375H20.625V20.625H16.875C9.62625 20.625 3.75 14.7487 3.75 7.5V3.75H11.25ZM30 28.125H15V37.5H30V28.125ZM35.625 9.375H32.8125C28.1531 9.375 24.375 13.1531 24.375 17.8125V18.75H27.1875C31.8469 18.75 35.625 14.9719 35.625 10.3125V9.375ZM11.25 7.5H7.5C7.5 12.6769 11.6981 16.875 16.875 16.875H20.625C20.625 11.6981 16.4269 7.5 11.25 7.5Z",
    fill: "#F4511E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantSign);
export default __webpack_public_path__ + "static/media/plant-sign.5310302db0e60ac2068bb1324c843f7c.svg";
export { ForwardRef as ReactComponent };